import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRecreatePrioShare } from '../../../api';

interface RecreatePrioShareParams {
  prioShareId: string;
  projectExtensionId: string;
}

export function useRecreatePrioShare() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: RecreatePrioShareParams) => {
      return apiRecreatePrioShare(
        params.projectExtensionId,
        params.prioShareId
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', variables.projectExtensionId],
      });
    },
  });
}
